import { Menu } from '@mui/material';
import { PopoverProps } from 'src/components/PopoverTrigger';
import { UserRecentFeature } from 'src/generated/graphql';
import { useRecentRegister } from 'src/sections/@dashboard/recents/shared';
import { DocTrashContent } from '../../pages/dashboard/DocsPage/DocTrashContent/DocTrashContent';

export const DocsTrashPopover = ({
  target,
  handleClose,
}: PopoverProps<any>) => {
  const open = Boolean(target);
  useRecentRegister({ feature: UserRecentFeature.Docs });

  return (
    <Menu
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <DocTrashContent />
    </Menu>
  );
};
